"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeLink = exports.makeNaked = exports.makeNav = exports.makeSecondary = exports.makePrimary = void 0;
// TODO: create types for styled components properly
// https://styled-components.com/docs/api#using-custom-props
// @ts-nocheck
var styled_components_1 = __importStar(require("styled-components"));
var helpers_1 = require("src/providers/theme/helpers");
var margin_1 = __importDefault(require("src/utilities/styled/margin"));
var alignSelf_1 = __importDefault(require("src/utilities/styled/alignSelf"));
var fill_1 = __importDefault(require("src/utilities/styled/fill"));
var makeFontSize_1 = __importDefault(require("src/utilities/styled/makeFontSize"));
var makeLineHeight_1 = __importDefault(require("src/utilities/styled/makeLineHeight"));
var hoverIndicator_1 = __importDefault(require("src/utilities/styled/hoverIndicator"));
var colorVariations_1 = __importDefault(require("src/utilities/styled/colorVariations"));
var disabled_1 = __importDefault(require("src/utilities/styled/disabled"));
var makePadding_1 = __importDefault(require("./utilities/makePadding"));
var makeColor_1 = __importDefault(require("./utilities/makeColor"));
var makeBackground_1 = __importDefault(require("./utilities/makeBackground"));
var makeFontWeight_1 = __importDefault(require("./utilities/makeFontWeight"));
var makeBorderRadius_1 = __importDefault(require("./utilities/makeBorderRadius"));
var makeBorder_1 = __importDefault(require("./utilities/makeBorder"));
var outline_1 = __importDefault(require("./utilities/outline"));
var withButton_1 = __importDefault(require("./withButton"));
var makeButton = function (type) { return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  background-color: ", ";\n  color: ", ";\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  text-decoration: none;\n  cursor: pointer;\n\n  &:hover {\n    background-color: ", ";\n    color: ", ";\n    ", "\n  }\n\n  &:active {\n    background-color: ", ";\n    color: ", ";\n    ", "\n  }\n"], ["\n  display: inline-block;\n  background-color: ", ";\n  color: ", ";\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  text-decoration: none;\n  cursor: pointer;\n\n  &:hover {\n    background-color: ", ";\n    color: ", ";\n    ", "\n  }\n\n  &:active {\n    background-color: ", ";\n    color: ", ";\n    ", "\n  }\n"])), (0, makeBackground_1.default)(type), (0, makeColor_1.default)(type), (0, makeBorder_1.default)(type), (0, makeFontSize_1.default)('text'), (0, makeLineHeight_1.default)('text'), (0, makeFontWeight_1.default)(type), (0, makeBorderRadius_1.default)(type), (0, makePadding_1.default)(type), disabled_1.default, margin_1.default, alignSelf_1.default, fill_1.default, outline_1.default, (0, makeBackground_1.default)(type, { hovered: true }), (0, makeColor_1.default)(type, { hovered: true }), (0, makeBorder_1.default)(type, { hovered: true }), (0, makeBackground_1.default)(type, { active: true }), (0, makeColor_1.default)(type, { active: true }), (0, makeBorder_1.default)(type, { active: true })); };
var makePrimary = function (Component) {
    return (0, withButton_1.default)((0, styled_components_1.default)(Component).withConfig(helpers_1.styledComponentsConfig).attrs(function (_a) {
        var _b = _a.margin, margin = _b === void 0 ? [0] : _b;
        return ({
            margin: margin,
        });
    })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), makeButton('primary')));
};
exports.makePrimary = makePrimary;
var makeSecondary = function (Component) {
    return (0, withButton_1.default)((0, styled_components_1.default)(Component).withConfig(helpers_1.styledComponentsConfig).attrs(function (_a) {
        var _b = _a.margin, margin = _b === void 0 ? [0] : _b;
        return ({
            margin: margin,
        });
    })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), makeButton('secondary')));
};
exports.makeSecondary = makeSecondary;
var makeNav = function (Component) {
    return (0, withButton_1.default)((0, styled_components_1.default)(Component).withConfig(helpers_1.styledComponentsConfig).attrs(function (_a) {
        var _b = _a.margin, margin = _b === void 0 ? [0] : _b;
        return ({
            margin: margin,
        });
    })(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), makeButton('nav')));
};
exports.makeNav = makeNav;
var makeNaked = function (Component) {
    return (0, withButton_1.default)((0, styled_components_1.default)(Component).withConfig(helpers_1.styledComponentsConfig).attrs(function (_a) {
        var _b = _a.margin, margin = _b === void 0 ? [0] : _b, _c = _a.hoverIndicator, hoverIndicator = _c === void 0 ? 'underline' : _c;
        return ({
            margin: margin,
            hoverIndicator: hoverIndicator,
        });
    })(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: inline-block;\n  color: ", ";\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n\n  background: transparent;\n  border: initial;\n  ", "\n"], ["\n  display: inline-block;\n  color: ", ";\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n\n  background: transparent;\n  border: initial;\n  ", "\n"])), function (props) { return (0, colorVariations_1.default)(props, props.theme.palette.buttonColor[5]); }, (0, makeFontSize_1.default)('text'), (0, makeLineHeight_1.default)('text'), function (_a) {
        var theme = _a.theme, strong = _a.strong;
        return "font-weight: " + theme.buttons.naked.fontWeight[strong ? 1 : 0] + ";";
    }, (0, makePadding_1.default)('naked'), disabled_1.default, margin_1.default, alignSelf_1.default, fill_1.default, outline_1.default, hoverIndicator_1.default));
};
exports.makeNaked = makeNaked;
var makeLink = function (Component) {
    return (0, withButton_1.default)((0, styled_components_1.default)(Component).withConfig(helpers_1.styledComponentsConfig).attrs(function (_a) {
        var _b = _a.margin, margin = _b === void 0 ? [0] : _b, _c = _a.hoverIndicator, hoverIndicator = _c === void 0 ? 'underline' : _c, _type = _a.type, rest = __rest(_a, ["margin", "hoverIndicator", "type"]);
        var secondary = rest.secondary, tertiary = rest.tertiary;
        var type = 'linkPrimary';
        if (secondary || _type === 'secondary') {
            type = 'linkSecondary';
        }
        if (tertiary || _type === 'tertiary') {
            type = 'linkTertiary';
        }
        return {
            margin: margin,
            hoverIndicator: hoverIndicator,
            type: type,
        };
    })(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  display: inline-block;\n  ", "\n  ", "\n  color: ", ";\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  background: transparent;\n  border: initial;\n  ", "\n\n  &:hover {\n    color: ", ";\n  }\n\n  ", "\n"], ["\n  display: inline-block;\n  ", "\n  ", "\n  color: ", ";\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  background: transparent;\n  border: initial;\n  ", "\n\n  &:hover {\n    color: ", ";\n  }\n\n  ", "\n"])), function (_a) {
        var fontSize = _a.fontSize;
        return (0, makeFontSize_1.default)(fontSize || 'text');
    }, (0, makeLineHeight_1.default)('text'), function (_a) {
        var type = _a.type;
        return (0, makeColor_1.default)(type);
    }, function (_a) {
        var theme = _a.theme, strong = _a.strong;
        return "font-weight: " + theme.buttons.link.fontWeight[strong ? 1 : 0] + ";";
    }, (0, makePadding_1.default)('link'), disabled_1.default, margin_1.default, alignSelf_1.default, fill_1.default, outline_1.default, hoverIndicator_1.default, function (_a) {
        var type = _a.type;
        return (0, makeColor_1.default)(type, { hovered: true });
    }, function (props) { return props.type === 'linkSecondary' && "\n    text-decoration: underline;\n  "; }));
};
exports.makeLink = makeLink;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
